import { Component } from 'react';
import { Image, Message, Table, List, Checkbox, Segment } from 'semantic-ui-react';
import logo from '../../assets/logo.png';
// import './AssessmentReportStep2.css';
//import data from '../../checklistComponents.json';

class ReportOneStep extends Component {

    displayError = (error, title, message) => {
        return (<Message negative><Message.Header>{title}</Message.Header>{message}</Message>);
    }

    getProjectTitle = () => {
        let title = '';
        this.props.projectState.project.title.forEach(item => {
            if (item.translation !== '') {
                title = item.translation + ' - ' + item.language;
            }
            if (item.language === 'EN' && item.translation !== '') {
                title = item.translation;
            }
        });
        return (title);
    }

    renderProjectDescription = () => {
        return (
            <Table celled>
                <Table.Body>
                    <Table.Row key="0-1">
                        <Table.Cell width="4">Project Number</Table.Cell>
                        <Table.Cell>{this.props.projectState.project.customIdentifier}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-2">
                        <Table.Cell >Project Acronym</Table.Cell>
                        <Table.Cell>{this.props.projectState.project.acronym}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-3">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{this.getProjectTitle()}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }

    getProgrammePriority = () => {
        const programmePriorityCode = this.props.projectState.project.programmePriority.code;
        let programmePriorityTranslation
        this.props.projectState.project.programmePriority.title.forEach(item => {
            if (item.language === 'EN') {
                programmePriorityTranslation = item.translation;
            }
        });
        return (programmePriorityCode + ' - ' + programmePriorityTranslation);
    }

    renderProjectPriority = () => {
        try {
            return (
                <Table celled>
                    <Table.Body>
                        <Table.Row key="1-1">
                            <Table.Cell width="4">Priority</Table.Cell>
                            <Table.Cell>{this.getProgrammePriority()}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-2">
                            <Table.Cell>Specific Objective</Table.Cell>
                            <Table.Cell>{this.props.projectState.project.specificObjective.code} - {this.props.projectState.project.specificObjective.programmeObjectivePolicy}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-3">
                            <Table.Cell>LP Name</Table.Cell>
                            <Table.Cell>{this.props.projectState.leadPartner.nameInEnglish}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-4">
                            <Table.Cell>LP Country</Table.Cell>
                            <Table.Cell>{this.props.projectState.leadPartner.addresses[0].countryCode}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>);
        } catch (error) {
            return this.displayError(error, "Can't find data for Project Priority", 'Please Check JEMS APP data');
        }
    }

    renderProjectCosts = () => {
        try {
            return (
                <Table celled>
                    <Table.Body>
                        <Table.Row key="2-1">
                            <Table.Cell width="4">Total eligible budget</Table.Cell>
                            {this.props.projectState.project.coFinancing ? <Table.Cell>{'€ ' + this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalFundAndContribution.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}

                        </Table.Row>
                        <Table.Row key="2-2">
                            <Table.Cell>Total ERDF requested</Table.Cell>
                            {this.props.projectState.project.coFinancing ? <Table.Cell>{'€ ' + this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalEuFundingAmount.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                        </Table.Row >
                    </Table.Body>
                </Table>);
        } catch (error) {
            return this.displayError(error, "Can't find data for Project Costs", 'Please Check JEMS APP data');
        }
    }

    getCheckListById = (id) => {
        let checkList = {};
        const checkLists = this.props.projectState.projectChecklists;
        checkLists.forEach(item => {
            if (item.id === id) {
                checkList = item;
            };
        });
        return checkList;
    }

    getChecklistByName = (name) => {
        let checklist = undefined;
        const checklists = this.props.projectState.projectChecklists;
        try {
            for (let i = 0; i < checklists.length; i++) {
                if (checklists[i].name === name) {
                    checklist = checklists[i];
                    return checklist;
                }
            }
        } catch (error) {
            return undefined
        }
    }

    renderProjectSummary = () => {
        try {
            const projectSummaryName = this.props.projectState.step2SummaryCheckList;
            const projectSummary = this.getChecklistByName(projectSummaryName);
            let summaryComponents = projectSummary.detail.components;
            let sortedSummaryComponents = summaryComponents.slice().sort((a, b) => a.position - b.position);
            return (
                <List>
                    {sortedSummaryComponents.map(item => {
                        if (item.type !== 'HEADLINE') {
                            return (
                                <List.Item className='line-break'>{item.instanceMetadata ? item.instanceMetadata.explanation : undefined}</List.Item>
                            );
                        } else {
                            return undefined;
                        }
                    })}
                </List>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Summary checklist of project", 'Please Check JEMS APP data');
        }
    }

    renderEligibilityChecklist = () => {
        try {
            const eligibilityChecklistName = this.props.projectState.oneStepEligibility;
            const eligibilityChecklist = this.getChecklistByName(eligibilityChecklistName);
            let eligibilityComponents = eligibilityChecklist.detail.components;
            let sortedComponents = eligibilityComponents.slice().sort((a, b) => a.position - b.position);
            return (
                <div>
                    <Table celled>
                        <Table.Header className='table-header'>
                            <Table.Row key="0" style={this.headerStyle}>
                                <Table.Cell>Criteria</Table.Cell>
                                <Table.Cell>Y/N</Table.Cell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {sortedComponents.map(item => {
                                if (item.instanceMetadata) {
                                    return (
                                        <Table.Row key={item.id}>
                                            <Table.Cell>{item.programmeMetadata.question} {item.instanceMetadata.justification ? <Message className='line-break' content={item.instanceMetadata.justification} /> : undefined}</Table.Cell>
                                            <Table.Cell>{item.instanceMetadata.answer}</Table.Cell>
                                        </Table.Row>
                                    );
                                } else {
                                    return (
                                        <Table.Row key={item.id}>
                                            <Table.Cell>{item.programmeMetadata.question}<Message warning>There is no data for this Criteria</Message></Table.Cell>
                                            <Table.Cell></Table.Cell>
                                        </Table.Row>
                                    );
                                }
                            })}
                        </Table.Body>
                    </Table>
                    {(this.props.projectState.project.secondStepDecision && this.props.projectState.project.secondStepDecision.eligibilityAssessment) ?
                        <div>
                            {this.props.projectState.project.secondStepDecision.eligibilityAssessment.result === 'PASSED' ?
                                <Segment.Group horizontal>
                                    <Segment>Eligibility decision: </Segment>
                                    <Segment><Checkbox label='Eligible' readOnly defaultChecked /></Segment>
                                    <Segment><Checkbox label='Not eligible' readOnly /></Segment>
                                </Segment.Group>
                                : <Segment.Group horizontal>
                                    <Segment>Eligibility decision: </Segment>
                                    <Segment><Checkbox label='Eligible' readOnly /></Segment>
                                    <Segment><Checkbox label='Not eligible' readOnly defaultChecked /></Segment>
                                </Segment.Group>
                            }
                        </div>
                        : <Message negative><Message.Header>Can't find data for elligibity assessment decision</Message.Header>Please Check JEMS APP configuration</Message>
                    }

                </div>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Eligibility checklist", 'Please Check JEMS APP data');
        }
    }


    getQualityAssessmentSummary = () => {
        const qualityChecklistName = this.props.projectState.step2Quality;
        const qualityChecklist = this.getChecklistByName(qualityChecklistName);
        let qualityComponents = qualityChecklist.detail.components;
        let sortedComponents = qualityComponents.slice().sort((a, b) => a.position - b.position);
        let qualitySummary = [];
        for (let i = 0; i < sortedComponents.length; i += 2) {
            if (sortedComponents[i].type === 'HEADLINE') {
                let qs = {};
                qs.question = sortedComponents[i].programmeMetadata.value
                qs.score = sortedComponents[i + 1].instanceMetadata.score
                qs.weight = Number(sortedComponents[i + 1].programmeMetadata.weight) * 100 + '%'
                qs.justification = sortedComponents[i + 1].instanceMetadata.justification
                qs.headlineQuestion = sortedComponents[i + 1].programmeMetadata.question
                qs.weightedScore = Number(sortedComponents[i + 1].programmeMetadata.weight) * Number(sortedComponents[i + 1].instanceMetadata.score)
                qualitySummary.push(qs);
            }
        }
        return qualitySummary;
    }

    renderQualityAssessmentSummary = () => {
        try {
            const qualityAssessmentSummary = this.getQualityAssessmentSummary();
            return (
                <div>
                    <Table celled>
                        <Table.Header >
                            <Table.Row key="0" className='table-header'>
                                <Table.Cell>Quality Assessment Summary</Table.Cell>
                                <Table.Cell textAlign='center'>Score (1-5)</Table.Cell>
                                <Table.Cell textAlign='center'>Weight</Table.Cell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {qualityAssessmentSummary.map(item => {
                                return (
                                    <Table.Row key={item.id}>
                                        <Table.Cell>{item.question}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.score}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.weight}</Table.Cell>
                                    </Table.Row>
                                )
                            })}
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row className='table-footer'>
                                <Table.Cell textAlign='right'>Total</Table.Cell>
                                <Table.Cell textAlign='center'>{qualityAssessmentSummary.reduce((accumulator, a) => accumulator + a.weightedScore, 0).toFixed(2)}</Table.Cell>
                                <Table.Cell textAlign='right'></Table.Cell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                    {(this.props.projectState.project.secondStepDecision && this.props.projectState.project.secondStepDecision.qualityAssessment) ?
                        <div>
                            {this.props.projectState.project.secondStepDecision.qualityAssessment.result === 'NOT_RECOMMENDED' ?
                                <Segment.Group horizontal>
                                    <Segment>JS Recommendation: </Segment>
                                    <Segment><Checkbox label='Approval with conditions' readOnly /></Segment>
                                    <Segment><Checkbox label='Rejection' readOnly defaultChecked /></Segment>
                                </Segment.Group>
                                : <Segment.Group horizontal>
                                    <Segment>JS Recommendation: </Segment>
                                    <Segment><Checkbox label='Approval with conditions' readOnly defaultChecked /></Segment>
                                    <Segment><Checkbox label='Rejection' readOnly /></Segment>
                                </Segment.Group>
                            }
                        </div>
                        : <Message negative><Message.Header>Can't find data for quality assessment decision</Message.Header>Please Check JEMS APP data</Message>
                    }
                </div>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Quality checklist summary", 'Please Check JEMS APP data');
        }
    }

    renderQualityAssessment = () => {
        try {
            const qualityAssessmentSummary = this.getQualityAssessmentSummary();
            return (
                <div>
                    {qualityAssessmentSummary.map(item => {
                        return (
                            <div className="criterion" width='100%'>
                                <Table celled>
                                    <Table.Body>
                                        <Table.Row key={item.id}>
                                            <Table.Cell>
                                                <p className="criterion-title">{item.question}</p>
                                                <p>{item.headlineQuestion}</p>
                                            </Table.Cell>
                                            <Table.Cell width="2" textAlign='center'>Score ({item.weight})</Table.Cell>
                                            <Table.Cell width="1" textAlign='center'>{item.score}</Table.Cell>
                                        </Table.Row>
                                        {item.justification ?
                                            <Table.Row key={item.id}>
                                                <Table.Cell colSpan='3'><Message content={item.justification} className='line-break' /></Table.Cell>
                                            </Table.Row>
                                            : undefined}
                                    </Table.Body>
                                </Table>
                            </div>
                        )
                    })}
                </div>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Quality Checklist", 'Please Check JEMS APP data');
        }
    }

    getJsOpinion = () => {
        const jsOpinionChecklistName = this.props.projectState.step2JSOpinion;
        const jsOpinionChecklist = this.getChecklistByName(jsOpinionChecklistName);
        let jsOpinionComponents = jsOpinionChecklist.detail.components;
        let sortedComponents = jsOpinionComponents.slice().sort((a, b) => a.position - b.position);
        let jsOpinion = {};
        jsOpinion.details = [];
        jsOpinion.summary = sortedComponents[1].instanceMetadata.explanation;
        jsOpinion.opinion = sortedComponents[2].instanceMetadata.answer;
        jsOpinion.opinionDetail = sortedComponents[2].instanceMetadata.justification;
        for (let i = 3; i < sortedComponents.length; i++) {
            if (sortedComponents[i].type === 'TEXT_INPUT') {
                let detail = {};
                detail.question = sortedComponents[i].programmeMetadata.question;
                detail.explanation = sortedComponents[i].instanceMetadata.explanation;
                jsOpinion.details.push(detail);
            }
        }
        return jsOpinion;
    }

    renderJSOpinion = () => {
        try {
            const jsOpinion = this.getJsOpinion();
            return (
                <div className='full-width line-break'>
                    {jsOpinion.summary}
                    <div className='little-margin'>
                        <h3 className='little-margin'>{jsOpinion.opinion}</h3>
                        {jsOpinion.opinionDetail ? <p>{jsOpinion.opinionDetail}</p> : undefined}
                        <List>
                            {jsOpinion.details.map(item => {
                                return (
                                    item.explanation ?
                                        <List.Item className='prevent-page-break'>
                                            <p className="criterion-title">{item.question}</p><Message content={item.explanation} className='line-break' />
                                        </List.Item>
                                        : undefined
                                )
                            })}
                        </List>
                    </div>
                </div>
            )
        } catch (error) {
            return this.displayError(error, "Can't find data for JS Opinion Checklist", 'Please Check JEMS APP data');
        }
    }

    getPartnerName = (partnerIndex) => {
        const partner = this.props.projectState.partners.find(partner => partner.sortNumber === partnerIndex)
        return (partner.detail.nameInEnglish);
    }

    renderGberProposal = (proposalGber, question) => {
        switch (proposalGber) {
            case 'Article 20':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20a' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            case 'Article 20a':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20a' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            default:
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20a' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly defaultChecked /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
        }
    }
    renderProposal = (proposal, question) => {
        switch (proposal) {
            case 'De minimis':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='De minimis' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Other' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            case 'Other':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='De minimis' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Other' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            default:
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='De minimis' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Other' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly defaultChecked /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
        }
    }

    renderStateAid = () => {
        try {
            const projectStateAid1Name = this.props.projectState.step2StateAid1;
            const projectStateAid1 = this.getChecklistByName(projectStateAid1Name);
            let stateAidComponents = [];
            let stateAid1components = projectStateAid1.detail.components ? projectStateAid1.detail.components : [];
            stateAid1components = stateAid1components.slice().sort((a, b) => a.position - b.position);
            stateAidComponents = stateAidComponents.concat(stateAid1components);
            if (this.props.projectState.partners.length > 12) {
                const projectStateAid2Name = this.props.projectState.step2StateAid2;
                const projectStateAid2 = this.getChecklistByName(projectStateAid2Name);
                if (!projectStateAid2) throw new Error('partnerNumberError');
                let stateAid2components = projectStateAid2.detail.components ? projectStateAid2.detail.components : [];
                stateAid2components = stateAid2components.slice().sort((a, b) => a.position < b.position ? -1 : 1);
                stateAidComponents = stateAidComponents.concat(stateAid2components)
            }

            let filteredComponents = [];
            let partnerNumber = 0;
            for (let i = 0; i < stateAidComponents.length; i++) {
                if (stateAidComponents[i + 1] && (stateAidComponents[i].type === 'HEADLINE' && stateAidComponents[i + 1].type === 'OPTIONS_TOGGLE') && partnerNumber < this.props.projectState.partners.length) {
                    partnerNumber++;
                    let component = {};
                    component.dataSelfCheck = {};
                    component.options = [];
                    component.partnerNumber = partnerNumber;
                    component.proposalGber = {};
                    component.proposal = {};
                    for (let j = 0; j < 6; j++) {
                        if (stateAidComponents[i + j].programmeMetadata.type === 'HEADLINE') {
                            component.title = stateAidComponents[i + j]
                            component.partnerName = this.getPartnerName(partnerNumber);
                        } else if (stateAidComponents[i + j].programmeMetadata.type === 'OPTIONS_TOGGLE' && stateAidComponents[i + j].programmeMetadata.question === ' ') {
                            component.dataSelfCheck = stateAidComponents[i + j];
                        } else if (stateAidComponents[i + j].programmeMetadata.type === 'OPTIONS_TOGGLE') {
                            component.options.push(stateAidComponents[i + j]);
                        }
                    }
                    component.proposalGber = stateAidComponents[i + 6];
                    component.proposal = stateAidComponents[i + 7];
                    filteredComponents.push(component);
                }
            }

            const temp = filteredComponents.find((component) => !component.dataSelfCheck.instanceMetadata);
            if (temp) throw new Error('checklistNotFilled');

            return (
                <div>
                    <h3 className='sub-title'>{stateAidComponents[0].programmeMetadata.value}</h3>
                    <h4 className='little-margin'>{stateAidComponents[1].programmeMetadata.question}</h4>
                    <p className='little-margin'>{stateAidComponents[1].instanceMetadata.explanation}</p>
                    {stateAidComponents[2].instanceMetadata.answer === 'Yes' ?
                        <Segment.Group horizontal>
                            <Segment>{stateAidComponents[2].programmeMetadata.question}</Segment>
                            <Segment><Checkbox width={2} label='Yes' readOnly defaultChecked /></Segment>
                            <Segment><Checkbox width={2} label='No' readOnly /></Segment>
                        </Segment.Group>
                        :
                        <Segment.Group horizontal>
                            <Segment>{stateAidComponents[2].programmeMetadata.question}</Segment>
                            <Segment><Checkbox width={2} label='Yes' readOnly /></Segment>
                            <Segment><Checkbox width={2} label='No' readOnly defaultChecked /></Segment>
                        </Segment.Group>
                    }
                    {stateAidComponents[2].instanceMetadata.justification ? <p>{<Message content={stateAidComponents[2].instanceMetadata.justification} className='line-break' />}</p> : undefined}
                    {stateAidComponents[2].instanceMetadata.answer === 'Yes' ?
                        <h3 className='sub-title'>{stateAidComponents[3].programmeMetadata.value}</h3>
                        : undefined
                    }
                    {filteredComponents.map(item => {
                        return (
                            <div className='little-margin'>
                                {item.dataSelfCheck.instanceMetadata.answer === 'Yes' ?
                                    <div >
                                        <Table celled>
                                            <Table.Header className='table-header'>
                                                <Table.Row key="0">
                                                    <Table.Cell>{item.partnerName + ' - ' + item.title.programmeMetadata.value}</Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='Yes' readOnly defaultChecked /></Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='No' readOnly /></Table.Cell>
                                                </Table.Row>
                                            </Table.Header>
                                        </Table>
                                    </div>
                                    :
                                    <div>
                                        <Table celled>
                                            <Table.Header className='table-header'>
                                                <Table.Row key="0">
                                                    <Table.Cell>{item.partnerName + ' - ' + item.title.programmeMetadata.value}</Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='Yes' readOnly /></Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='No' readOnly defaultChecked /></Table.Cell>
                                                </Table.Row>
                                            </Table.Header>
                                        </Table>

                                        <Table celled>
                                            <Table.Header className='table-header'>
                                                <Table.Row key="0" style={this.headerStyle}>
                                                    <Table.Cell>Questions</Table.Cell>
                                                    <Table.Cell width={2}>Yes/No</Table.Cell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {item.options.map(option => {
                                                    return (
                                                        <Table.Row key={option.id}>
                                                            <Table.Cell className='line-break'>{option.programmeMetadata.question} {option.instanceMetadata.justification ? <Message className='line-break' content={option.instanceMetadata.justification} /> : undefined}</Table.Cell>
                                                            <Table.Cell>{option.instanceMetadata.answer}</Table.Cell>
                                                        </Table.Row>
                                                    )
                                                })}
                                            </Table.Body>
                                        </Table>
                                        <div className='little-margin'>
                                            {this.renderGberProposal(item.proposalGber.instanceMetadata.answer, item.proposalGber.programmeMetadata.question)}
                                            {item.proposalGber.instanceMetadata.justification ? <p className='no-margin'>{<Message content={item.proposalGber.instanceMetadata.justification} />}</p> : undefined}
                                        </div>
                                        <div className='little-margin'>
                                            {this.renderProposal(item.proposal.instanceMetadata.answer,item.proposal.programmeMetadata.question)}
                                            {item.proposal.instanceMetadata.justification ? <p className='no-margin'>{<Message content={item.proposal.instanceMetadata.justification} />}</p> : undefined}
                                        </div>
                                    </div>
                                }
                            </div>
                        )
                    })}
                </div>
            );

        } catch (error) {
            switch (error.message) {
                case 'partnerNumberError':
                    return this.displayError(error, "There is more partners than permited by checklists", 'Please Check the State Aid checklists for this project');
                case 'checklistNotFilled':
                    return this.displayError(error, "It seems a checklist is still empty", 'Please Check the State Aid checklists for this project');
                default:
                    return <Message>There is no detailed State aid assessment available for this application, as it is not recommended for approval.</Message>;
            }
        }
    }

    render() {
        return (
            <div className='margin-report-2'>
                <table >
                    <thead>
                        <tr>
                            <th><Image src={logo} size='medium' /></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className='page-break full-width'>
                            <td>
                                <h2 className='title'>Assessment Report </h2>
                                {this.renderProjectDescription()}
                                {this.renderProjectPriority()}
                                {this.renderProjectCosts()}
                                <h3 >Summary of project</h3>
                                {this.renderProjectSummary()}

                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td>
                                <h3>Eligibility CheckList</h3>
                                {this.renderEligibilityChecklist()}
                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td>
                                <h3>Quality Assessment</h3>
                                {this.renderQualityAssessmentSummary()}
                                {this.renderQualityAssessment()}
                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td>
                                <h3>JS Opinion</h3>
                                {this.renderJSOpinion()}
                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td className='parentTableRow'>
                                <h3 className='childTableRow'>State Aid</h3>
                                <div className='childTableRow'>{this.renderStateAid()}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ReportOneStep;